jQuery(function ($) {
  var selectDiv = $(".map-selector");
  if (selectDiv.length) {
    console.log("Loaded map.js");
    selectDiv.empty();
    selectDiv.css("background", "#1EB47B");
    selectDiv.css("color", "#000000");
    selectDiv.append("<div class='map-select-wrapper'></div>");
    var wrapper = $(".map-select-wrapper");
    wrapper.append("<div class='selector-wrapper'></div>");
    var mobileWrapper = $(".selector-wrapper");
    // mobile
    mobileWrapper.append(
      '<div class=\'clicker\'><img class=\'toggle-img toggle-trans\' src=\'/wp-content/themes/hankodataparks2018/assets/hidden.svg\' onclick=\'handleToggle(["Transport", "Mainroad", "Railroads"], "trans")\'><p onclick=\'handleToggle(["Transport", "Mainroad", "Railroads"], "trans")\' class=\'toggler\'>Transport</p></div>'
    );
    mobileWrapper.append(
      '<div class=\'clicker\'><img class=\'toggle-img toggle-visible toggle-local\' src=\'/wp-content/themes/hankodataparks2018/assets/visible.svg\' onclick=\'handleToggle(["Local_grid_110_kV_200_MW", "Power", "Fingrid_400kV", "Fingrid_110_kV"], "local")\'><p onclick=\'handleToggle(["Local_grid_110_kV_200_MW", "Power", "Fingrid_400kV", "Fingrid_110_kV"], "local")\' class=\'toggler\'>Power grid</p></div>'
    );
    /*mobileWrapper.append(
      "<div class='clicker'><img class='toggle-img toggle-fin' src='/wp-content/themes/hankodataparks2018/assets/hidden.svg' onclick='handleToggle([\"Fingrid_400kV\", \"Fingrid_110_kV\"], \"fin\")'><p onclick='handleToggle([\"Fingrid_400kV\", \"Fingrid_110_kV\"], \"fin\")' class='toggler'>Fingrid, National grid</p></div>"
    );*/
    mobileWrapper.append(
      "<div class='clicker'><img class='toggle-img toggle-edu' src='/wp-content/themes/hankodataparks2018/assets/hidden.svg' onclick='handleToggle([\"Universities\"], \"edu\")'><p onclick='handleToggle([\"Universities\"], \"edu\")' class='toggler'>Education</p></div>"
    );
    // desktop
    wrapper.append(
      '<div class=\'clicker desktop\'><img class=\'toggle-img toggle-trans\' src=\'/wp-content/themes/hankodataparks2018/assets/hidden.svg\' onclick=\'handleToggle(["Transport", "Mainroad", "Railroads"], "trans")\'><p onclick=\'handleToggle(["Transport", "Mainroad", "Railroads"], "trans")\' class=\'toggler\'>Transport</p></div>'
    );
    wrapper.append(
      '<div class=\'clicker desktop\'><img class=\'toggle-img toggle-visible toggle-local\' src=\'/wp-content/themes/hankodataparks2018/assets/visible.svg\' onclick=\'handleToggle(["Local_grid_110_kV_200_MW", "Power", "Fingrid_400kV", "Fingrid_110_kV"], "local")\'><p onclick=\'handleToggle(["Local_grid_110_kV_200_MW", "Power", "Fingrid_400kV", "Fingrid_110_kV"], "local")\' class=\'toggler\'>Power grid</p></div>'
    );
    /*wrapper.append(
      "<div class='clicker desktop'><img class='toggle-img toggle-fin' src='/wp-content/themes/hankodataparks2018/assets/hidden.svg' onclick='handleToggle([\"Fingrid_400kV\", \"Fingrid_110_kV\"], \"fin\")'><p onclick='handleToggle([\"Fingrid_400kV\", \"Fingrid_110_kV\"], \"fin\")' class='toggler'>Fingrid, National grid</p></div>"
    );*/
    wrapper.append(
      "<div class='clicker desktop'><img class='toggle-img toggle-edu' src='/wp-content/themes/hankodataparks2018/assets/hidden.svg' onclick='handleToggle([\"Universities\"], \"edu\")'><p onclick='handleToggle([\"Universities\"], \"edu\")' class='toggler'>Education</p></div>"
    );
    var hidden = ["Transport", "Mainroad", "Railroads", "Universities"];
    window.onload = hideMapStuff(hidden, false);
  }
});

// Has to be window.* for the function to be available.
window.hideMapStuff = function (hidden, isHidden) {
  if (!isHidden) {
    setTimeout(function () {
      for (var i = 0; i < hidden.length; i++) {
        var mapitem = jQuery("#" + hidden[i]);
        if (mapitem.length) {
          mapitem.hide();
        } else {
          hideMapStuff(hidden, false);
        }
      }
    }, 500);
  }
}

// Has to be window.* for the function to be available.
window.handleToggle = function (elements, toggleId) {
  var img = jQuery(".toggle-" + toggleId);
  if (img.length) {
    if (img.hasClass("toggle-visible")) {
      img.attr(
        "src",
        "/wp-content/themes/hankodataparks2018/assets/hidden.svg"
      );
      img.toggleClass("toggle-visible");
    } else {
      img.attr(
        "src",
        "/wp-content/themes/hankodataparks2018/assets/visible.svg"
      );
      img.toggleClass("toggle-visible");
    }
  }
  for (var i = 0; i < elements.length; i++) {
    var e = jQuery("#" + elements[i]);
    if (e.length) {
      e.toggle("slow");
    }
  }
}